import { render } from "./DeclareSensitiveCheck.vue?vue&type=template&id=94ae0198"
import script from "./DeclareSensitiveCheck.vue?vue&type=script&lang=js"
export * from "./DeclareSensitiveCheck.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__